import { HttpClient, HttpContext, HttpStatusCode } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { SKIP_ERROR_TOAST } from 'src/app/core/constants/http-error-context';
import { getTenantId } from 'src/app/services/store-snapshot.service';
import { environment } from 'src/environments/environment';
import { IDocumentEditLock } from '../models/document-edit-lock.model';

@Injectable({
  providedIn: 'root',
})
export class DocumentEditLockApiService {
  constructor(private http: HttpClient) {}

  getLock(documentId: string): Observable<IDocumentEditLock | null> {
    return this.http
      .get<IDocumentEditLock | null>(this.urlFor(documentId), { observe: 'response' })
      .pipe(
        map((response) => {
          if (response.status === HttpStatusCode.NoContent || !response.body) {
            return null;
          }

          return response.body;
        })
      );
  }

  acquireLock(documentId: string): Observable<IDocumentEditLock> {
    return this.http.post<IDocumentEditLock>(this.urlFor(documentId), {});
  }

  heartbeatLock(documentId: string): Observable<IDocumentEditLock> {
    return this.http.put<IDocumentEditLock>(this.urlFor(documentId), {}, this.silentContext());
  }

  releaseLock(documentId: string): Observable<void> {
    return this.http.delete<void>(this.urlFor(documentId), this.silentContext());
  }

  private urlFor(documentId: string): string {
    return `${environment.apiUrl}/api/${getTenantId()}/documents/${documentId}/edit-lock`;
  }

  private silentContext(): { context: HttpContext } {
    return { context: new HttpContext().set(SKIP_ERROR_TOAST, true) };
  }
}
